import { ColorIndex, colorIndexFromUint8 } from "@nova/component-color-finder-legend/src/colorspace"
import { decompress } from "plugins/shared/compression"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"
import {
    INDEX_LENGTH_U32,
    INDEXES_PER_TILE,
} from "plugins/ColorFinder/processing/SuperIndexController.class"
import { buildTilePath } from "plugins/ColorFinder/VideoColorFinder/useColorFinderProcessing"
import { uint8ToUint32Array } from "tools/util-buffers"

const colorIndexCache = new Map<string, Promise<ColorIndex>>()

export const fetchLegacyColorFinderIndex = (
    s3Key: string,
    isDemo: boolean
): Promise<ColorIndex> => {
    const cachedPromise = colorIndexCache.get(s3Key)
    if (cachedPromise) {
        return cachedPromise
    }

    const newPromise = fileManagementApi
        .fetchFile(s3Key, { isDemo })
        .then((res) => res.arrayBuffer())
        .then((buf) => decompress<Uint8Array>(buf, "gzip"))
        .then<ColorIndex>((bytes) => colorIndexFromUint8(bytes))

    colorIndexCache.set(s3Key, newPromise)

    return newPromise
}

export const buildTileFetcher = (basePath: string, isDemo?: boolean): TileFetcher => {
    const tileFetcher: TileFetcher = async (zoom: number, tileNum: number) => {
        const tilePath = buildTilePath(basePath, zoom, tileNum)

        try {
            const response = await fileManagementApi.fetchFile(tilePath, { isDemo })

            if (!response.ok) {
                throw new Error(`Failed to fetch tile ${tilePath}: ${response.statusText}`)
            }

            const buffer = await response.arrayBuffer()

            const decompressedBytes = await decompress<Uint8Array>(buffer, "gzip")

            const tileData = uint8ToUint32Array(decompressedBytes)

            return tileData
        } catch (err) {
            console.error(`Failed to fetch tile ${tilePath}:`, err)
            return new Uint32Array(INDEX_LENGTH_U32 * INDEXES_PER_TILE)
        }
    }

    return tileFetcher
}

export type TileFetcher = (zoom: number, tileNum: number) => Promise<Uint32Array> | Uint32Array
